// @ts-strict-ignore
import React from 'react';
import { TextFieldFormComponent } from '@/formbuilder/TextFieldFormComponent.atom';
import { ValidatingFormComponent } from '@/formbuilder/formBuilder.constants';
import { getFormFieldWrapperProps } from '@/formbuilder/formbuilder.utilities';

export interface FormControlJsonIF extends ValidatingFormComponent<string | number> {
  component: 'JsonTextAreaFormComponent';
  placeholder?: string;
  onBlur?: (value: string) => void;
  type?: string;
  step?: number;
  size: 'sm' | 'lg';
  rows?: number;
  value: string;
  disabled?: boolean;
}

export const JsonTextAreaFormComponent: React.FunctionComponent<FormControlJsonIF> = (props) => {
  const {
    name,
    extendValidation,
    validation,
    placeholder,
    onChange,
    onBlur,
    customErrorText,
    type = 'textarea',
    step,
    size,
    rows,
    value,
    disabled,
  } = props;

  const specialError = React.useRef<string>(null);
  const jsonValidation = (value) => {
    try {
      JSON.parse(value.toString());
    } catch (e) {
      specialError.current = e.toString();
      return true;
    }
    return false;
  };

  const jsonCustomError = () => {
    if (customErrorText !== null && customErrorText !== undefined) {
      return customErrorText;
    }
    return specialError.current;
  };

  return (
    <TextFieldFormComponent
      component="TextFieldFormComponent"
      {...getFormFieldWrapperProps(props)}
      name={name}
      extendValidation={extendValidation}
      validation={(value) => {
        if (validation !== null && validation !== undefined) {
          return validation(value);
        }
        return jsonValidation(value);
      }}
      placeholder={placeholder}
      onChange={onChange}
      onBlur={onBlur}
      type="text"
      step={step}
      size={size}
      rows={rows}
      value={value}
      as="textarea"
      disabled={disabled}
      customErrorText={jsonCustomError()}
    />
  );
};
